import PropTypes from 'prop-types';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { useFloatingLabelFormElement } from '../../contexts/internal/floating-label/index.js';
import { useFormFieldProps } from '../form/form.context.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';
import { useId } from '../../hooks/use-id.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    /**
   * The error skin will show a red border around the element. The line skin removed all border except the bottom one
   */ skin: PropTypes.oneOf([
        'standard',
        'error',
        'line'
    ]),
    /**
   * @deprecated use `size` prop instead
   */ sizeVariant: deprecatedProp(PropTypes.oneOf([
        'standard',
        'mini'
    ]), DEPRECATED_PROP_MESSAGES.size),
    /**
   * Mini will make the dropdown smaller
   */ size: PropTypes.oneOf([
        'standard',
        'mini'
    ]),
    /**
   * whether or not the component should horizontally to fill its container's availableWidth
   */ fullWidth: PropTypes.bool,
    /**
   * @deprecated omit to use default styling instead
   */ rounded: deprecatedProp(PropTypes.bool, 'Omit to use default styling instead'),
    /**
   * @deprecated omit to use default styling instead
   *
   * Removes the visible border from around the dropdown
   */ borderless: deprecatedProp(PropTypes.bool, 'Omit to use default styling instead')
};
const Dropdown = createComponent({
    displayName: 'Dropdown',
    root: 'select',
    propTypes,
    propConfig: {
        processProps (props) {
            const id = useId(props.id);
            const floatingProps = useFloatingLabelFormElement(_object_spread_props(_object_spread({}, props), {
                id
            }));
            const formProps = useFormFieldProps(floatingProps.id);
            return _object_spread({}, floatingProps, formProps);
        },
        classNames (props) {
            const classNameSet = new Set([
                'swan-dropdown'
            ]);
            const { skin = 'standard', sizeVariant = 'standard', size = sizeVariant, fullWidth = false, rounded = false, borderless = false, 'aria-invalid': ariaInvalid } = props;
            if (size === 'mini') classNameSet.add(`swan-dropdown-mini`);
            if (skin === 'error' || ariaInvalid) classNameSet.add(`swan-dropdown-skin-error`);
            if (skin === 'line') classNameSet.add(`swan-dropdown-skin-line`);
            if (fullWidth) classNameSet.add(`swan-dropdown-full-width`);
            if (rounded) classNameSet.add(`swan-dropdown-rounded`);
            if (borderless) classNameSet.add(`swan-dropdown-borderless`);
            return classNameSet;
        }
    }
});
Dropdown.defaultProps = {
    skin: 'standard',
    size: 'standard'
};

export { Dropdown };
